document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.count-up-counter');
  const lang = document.documentElement.getAttribute('lang') || 'en';

  const formatNumber = (number, prefix = '', suffix = '') => {
    return prefix + number.toLocaleString(lang) + suffix;
  };


  const countUp = (el, start, end, duration, prefix = '', suffix = '') => {
    const incrementTime = 16;
    const steps = Math.ceil(duration / incrementTime);
    const stepValue = (end - start) / steps;
    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      const currentValue = Math.round(start + stepValue * currentStep);
      el.dataset.finalContent = formatNumber(currentValue, prefix, suffix);

      if (currentStep >= steps) {
        el.dataset.finalContent = formatNumber(currentValue, prefix, suffix);
        clearInterval(interval);
      }
    }, incrementTime);
  };

  const getCounterData = (el) => {
    return {
      start: parseInt(el.getAttribute('data-start'), 10),
      end: parseInt(el.getAttribute('data-end'), 10),
      duration: parseInt(el.getAttribute('data-duration'), 10),
      prefix: el.getAttribute('data-prefix'),
      suffix: el.getAttribute('data-suffix'),
    }
  }

  const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const data = getCounterData(el);

        countUp(el, data.start, data.end, data.duration, data.prefix, data.suffix);
        observer.unobserve(el);
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1,
  });

  counters.forEach(counter => {
    observer.observe(counter);
    const data = getCounterData(counter);
    counter.textContent = formatNumber(data.end, data.prefix, data.suffix);
  });
});



// WEBPACK FOOTER //
// ./scripts/components/count-up.js